// extracted by mini-css-extract-plugin
module.exports = {"title":"_5eea3","label":"_1a006","wrapper":"f70a4","compact":"_29b67","form":"_0f1d9","loading":"_7882f","checkbox":"db428","tags":"_4f785","footer":"_8ba22"};